import type { FC } from 'react';
import { createStyles, fade, makeStyles } from '@material-ui/core';
import type { Theme } from 'src/theme';

// body gets the theme font and colours so any bare element inherits them
// instead of falling back to Times New Roman.
const useStyles = makeStyles((theme: Theme) => createStyles({
  '@global': {
    '*': {
      boxSizing: 'border-box',
      margin: 0,
      padding: 0,
      // Firefox scrollbars follow the theme (see the WebKit rules below).
      scrollbarWidth: 'thin',
      scrollbarColor: `${fade(theme.palette.text.primary, 0.22)} transparent`
    },
    html: {
      '-webkit-font-smoothing': 'antialiased',
      '-moz-osx-font-smoothing': 'grayscale',
      height: '100%',
      width: '100%'
    },
    body: {
      height: '100%',
      width: '100%',
      fontFamily: theme.typography.fontFamily,
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.background.dark
    },
    '#root': {
      height: '100%',
      width: '100%'
    },
    // Scrollbars follow the theme (the defaults were a light-grey track that
    // glared in dark mode). WebKit/Chromium native bars:
    '*::-webkit-scrollbar': {
      width: 10,
      height: 10
    },
    '*::-webkit-scrollbar-track': {
      backgroundColor: 'transparent'
    },
    '*::-webkit-scrollbar-thumb': {
      backgroundColor: fade(theme.palette.text.primary, 0.22),
      borderRadius: 8,
      border: '2px solid transparent',
      backgroundClip: 'content-box'
    },
    '*::-webkit-scrollbar-thumb:hover': {
      backgroundColor: fade(theme.palette.text.primary, 0.38)
    },
    '*::-webkit-scrollbar-corner': {
      backgroundColor: 'transparent'
    },
    // react-perfect-scrollbar (sidebar, tables): its CSS paints the rail #eee
    // and the thumb #aaa.
    '.ps .ps__rail-x:hover, .ps .ps__rail-y:hover, .ps .ps__rail-x:focus, .ps .ps__rail-y:focus, .ps .ps__rail-x.ps--clicking, .ps .ps__rail-y.ps--clicking': {
      backgroundColor: fade(theme.palette.text.primary, 0.06)
    },
    '.ps__thumb-x, .ps__thumb-y': {
      backgroundColor: fade(theme.palette.text.primary, 0.22)
    },
    '.ps__rail-x:hover > .ps__thumb-x, .ps__rail-x:focus > .ps__thumb-x, .ps__rail-x.ps--clicking .ps__thumb-x, .ps__rail-y:hover > .ps__thumb-y, .ps__rail-y:focus > .ps__thumb-y, .ps__rail-y.ps--clicking .ps__thumb-y': {
      backgroundColor: fade(theme.palette.text.primary, 0.38)
    }
  }
}));

const GlobalStyles: FC = () => {
  useStyles();

  return null;
};

export default GlobalStyles;
